import { Box, IconButton, Tooltip } from "@mui/material";
import { HyperLinkTypography, StyledTableCell } from "../style";
import CopyIcon from "@mui/icons-material/ContentCopy";
import styled from "styled-components";
import useToaster from "../../../hooks/useToaster";
import useLanguage from "../../../hooks/useLanguage";

const FloatingCopyIcon = styled(IconButton)``;

const SmallCopyIcon = styled(CopyIcon)`
  font-size: 16px;
`;

const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
`;

export default function HyperLink({
  id,
  content,
  href,
  disableWrap,
  enableCopy,
  ...cellProps
}) {
  const [
    {
      components: { table: text },
    },
  ] = useLanguage();
  const { addToaster } = useToaster();
  const handleClick = () => {
    window.history.pushState({}, "", `${href}/${id ?? content}`);
    window.dispatchEvent(new PopStateEvent("popstate"));
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(content);
    addToaster({
      message: text.copyCell,
      severity: "info",
    });
  };

  return (
    <StyledTableCell {...cellProps}>
      <Wrapper>
        <Tooltip title={content} placement="top" enterDelay={1000}>
          <HyperLinkTypography
            variant="body2"
            onClick={handleClick}
            $truncate={disableWrap}
          >
            {content}
          </HyperLinkTypography>
        </Tooltip>

        {enableCopy && (
          <FloatingCopyIcon onClick={handleCopy}>
            <SmallCopyIcon />
          </FloatingCopyIcon>
        )}
      </Wrapper>
    </StyledTableCell>
  );
}
